<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <section v-else>
      <header class="header">
        <div class="title">商品防伪认证中心</div>
        <div class="round">
          <div class="round__body">
            <img src="/static/images/Normal22/round.png">
            <img class="line" src="/static/images/Normal22/round_line.png" />
            <div class="round__main">
              <p class="text">防伪查询</p>
              <p class="number" v-if="datas.scan_count <= 3" v-text="datas.scan_count"></p>
              <img class="img" v-else src="/static/images/Normal22/freeze.png">
              <p class="text">查询次数</p>
            </div>
          </div>
        </div>
        <div class="tit">防伪数码</div>
        <div class="code">
          <p class="box" v-text="code"></p>
        </div>
      </header>

      <div class="return">
        <div class="head">
          <img class="icon" src="/static/images/Normal22/info.png" />
          <span>防伪查询结果</span>
        </div>
        <div class="card">
          <div class="text" v-if="datas.scan_count == 1">您好，您所查询的是{{ datas.business.name }}的正牌产品，请放心使用！</div>
          <div class="text" v-else-if="datas.scan_count <= 3">
            您所查询的防伪码已被查询过，此次是第{{datas.scan_count}}次查询！首次查询时间：{{datas.scan_first_time}}，如不是您亲自查询，谨防假冒！
          </div>
          <div class="text" v-else>您好，您所查询的防伪码因查询次数过多已被冻结，谨防假冒! </div>
          <img class="img" src="/static/images/Normal22/seal.png" />
        </div>
      </div>

      <div class="divide-box"></div>

      <template v-if="datas.scan_count > 1 && datas.scan_count <= 3 && recordList.length">
        <div class="card record">
          <h2 class="title">真伪查询记录</h2>
          <div class="record__body">
            <ul class="row head">
              <li class="index">序号</li>
              <li class="date">查询时间</li>
              <li class="ip">查询IP或手机</li>
            </ul>
            <ul class="row" v-for="(item, index) in recordList" :key="index">
              <li class="index">{{index+1}}</li>
              <li class="date">{{item.created_at}}</li>
              <li class="ip">{{item.ip}}</li>
            </ul>
          </div>
        </div>
        <div class="divide-box"></div>
      </template>

      <div class="remind card">
        <div class="remind__head">
          <h2 class="title">验证提醒</h2>
          <p class="text">请对照您所购买的产品上的防伪码，依次输入防伪密码验证结果分为以下三种情况：</p>
        </div>

        <div class="remind__body">
          <div class="row">
            <img class="icon" src="/static/images/Normal22/success.png" />
            <h2 class="title">正确查询</h2>
            <p class="text">即您所购买的商品为正牌产品</p>
          </div>
          <div class="row">
            <img class="icon" src="/static/images/Normal22/warn.png" />
            <h2 class="title">重复查询</h2>
            <p class="text">即同一验证码被多次查验，请确认首次查验是否由您本人所为，若非本人所为，则可能为假冒商品。</p>
            <p class="divide"></p>
            <p class="text">
              <strong>条码冻结：</strong>
              <span>当同一防伪码被多次查验达到一定次数后，则该条码冻结状态。</span>
            </p>
          </div>
          <div class="row">
            <img class="icon" src="/static/images/Normal22/fail.png" />
            <h2 class="title">错误查询</h2>
            <p class="text">即验证码不存在，您所购买的产品未经官方验证</p>
          </div>
        </div>
      </div>

      <footer>
        <p>技术支持：链接科技有限公司 </p>
        <p>Copyright ©2021 商品防伪认证中心版权所有</p>
      </footer>

    </section>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal22',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      page: 1,
      code: null,
      vcode: null,
      count: 2,
      msg: '',
      datas: null,
      hintTxt: null,
      recordList: [],
      Loading: {
        type: 1,
        txt: "数据请求中..."
      }
    }
  },
  created() {
    self = this;
    document.body.style.backgroundColor = "rgb(255, 255, 255)";

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          localStorage.setItem("wwm_seedDetail", JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetRecord () {
      axios.get(this.GetServerUrl(1)+"queryList/" + this.code+ "/" + this.page)
      .then((response)=>{
        let datas = response.data.meta.data;
        if(datas.length){
          this.recordList = datas;
        }
      }).catch((error)=>{
        console.log(error)
      })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码

          //激活自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //发货自定义属性
          if (datas.dealer && datas.dealer.length) {
            datas.attribute = JSON.parse(datas.dealer[0].attribute);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          localStorage.setItem("wwm_seedDetail", JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题

          setTimeout(() => {
            self.GetRecord();
          });
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    }
  }
}
</script>

<style scoped lang="scss">
$margin: top, right, bottom, left;

@each $i in $margin {
  @for $j from 1 through 100 {
    $key: str-slice($i, 1, 1);

    .m#{$key}#{$j} {
      margin-#{$i}: $j + px !important;
    }
  }
}

.header {
  background-image: linear-gradient(to top left, #6e80f0, #2399dd);

  &::before{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('/static/images/Normal22/logo-bg.png') top center repeat-y;
    background-size: 100%;
    z-index: 0;
  }

  .title {
    color: #ffffff;
    text-align: center;
    padding: 1.1rem 0;
    font-size: .8rem;
    letter-spacing: 1px;
  }
  .tit{
    padding: .55rem 0;
    color: #ffffff;
    text-align: center;
  }
  .code{
    display: flex;
    padding-bottom: 2rem;
    flex-direction: row;
    .box{
      margin: auto;
      border-radius: 1rem;
      display: table;
      padding: .4rem .8rem;
      font-size: .65rem;
      color: #1073bf;
      background-color: #c0ebff;
    }
  }
}

.round {
  display: flex;

  .round__body {
    width: 10rem;
    height: 10rem;
    margin: auto;
    border-radius: 10rem;
    position: relative;
    border: 0.05rem solid rgba(255, 255, 255, 0.1);

    img {
      width: 100%;
      display: block;
    }

    .line {
      position: absolute;
      left: 0;
      top: 0;
      animation: spin 1.8s linear 0s infinite;
    }

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }

    .round__main {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: auto;
      color: white;
      text-align: center;

      .text {
        opacity: .6;
      }

      .img{
        width: 3rem;
        display: table;
        margin: .4rem auto;
      }

      .number {
        font-size: 3rem;
        padding: .3rem 0;
        font-weight: bold;
      }
    }
  }
}

.card {
  padding: 20px;
}

.return {
  position: relative;
  padding-bottom: 4.2rem;

  .head {
    display: flex;
    align-items: center;
    flex-direction: row;
    padding: 15px 20px;
    border-bottom: 1px solid #EEE;

    .icon {
      width: 25px;
      height: 25px;
      display: block;
      margin-right: 10px;
    }

    span {
      font-size: .6rem;
    }

  }

  .text {
    text-indent: 2em;
    line-height: .95rem;
    font-size: .57rem;
    color: #333333;
  }

  .img {
    width: 5rem;
    display: block;
    position: absolute;
    right: 30px;
    bottom: .6rem;
    transform: rotate(-20deg);
  }
}



.divide-box {
  height: .5rem;
  background-color: #f8f8f8;
}

.record {
  .title {
    font-size: .65rem;
    text-align: center;
  }

  .record__body {
    margin-top: .5rem;
    border: 1px solid #EEE;

    .head {
      font-weight: 600;
      background-color: #eaeaea;
    }

    .row {
      display: flex;
      text-align: center;
      flex-direction: row;
      color: #707070;
      font-size: .55rem;

      &:nth-child(2n-1){
        background-color: #f6f6f6;
      }
    }

    .index {
      width: 60px;
      padding: .4rem 0;
      border-right: 1px solid #EEE;
    }

    .date {
      flex: 1;
      padding: .4rem 10px;
      border-right: 1px solid #EEE;
    }

    .ip {
      padding: .4rem 10px;
      flex: 1;
    }
  }
}




.remind {
  padding-bottom: 0;

  .title {
    font-size: .53rem;
    color: #333333;
  }

  .text {
    color: #888888;
    font-size: .5rem;
    margin-top: 3px;
  }
}

.remind__head {
  .title {
    font-size: .58rem;
  }

  .text {
    margin-top: 5px;
  }
}

.remind__body {
  margin-top: 1rem;

  .row {
    position: relative;
    padding-left: 40px;
    padding-bottom: 20px;

    &::before {
      position: absolute;
      display: block;
      content: '';
      height: 100%;
      width: 1px;
      left: 15px;
      top: 0;
      background-color: #EEE;
    }

    &:first-child {
      margin-top: 0;
    }

    .icon {
      position: absolute;
      left: 0;
      top: -2px;
      width: 30px;
    }

    .divide {
      margin: 8px 0;
      border: 1px dashed #DDD;
    }
  }
}


//底部
footer {
  text-align: center;
  color: white;
  padding: .5rem 0;
  font-size: .52rem;
  background-image: linear-gradient(to top left, #6e80f0, #2399dd);
}</style>



// WEBPACK FOOTER //
// src/view/Normal22.vue